// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LotteryTagList_componentStyle__UVbd1","itemLink":"LotteryTagList_itemLink__6jY92"};